import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../store';

interface ITabScrollState {
  workflows: Record<string, Record<string, number>>;
}

const initialState: ITabScrollState = {
  workflows: {},
};

const tabScrollSlice = createSlice({
  name: 'tabScrollSlice',
  initialState,
  reducers: {
    saveScrollPosition(state, action: PayloadAction<{ workflowId: string; scrollKey: string; scrollTop: number }>) {
      const { workflowId, scrollKey, scrollTop } = action.payload;
      if (!state.workflows[workflowId]) {
        state.workflows[workflowId] = {};
      }
      state.workflows[workflowId][scrollKey] = scrollTop;
    },

    clearScrollPosition(state, action: PayloadAction<{ workflowId: string; scrollKey: string }>) {
      const { workflowId, scrollKey } = action.payload;
      if (state.workflows[workflowId]) {
        delete state.workflows[workflowId][scrollKey];
      }
    },

    clearByPrefix(state, action: PayloadAction<{ workflowId: string; prefix: string }>) {
      const { workflowId, prefix } = action.payload;
      const workflow = state.workflows[workflowId];
      if (workflow) {
        Object.keys(workflow).forEach(key => {
          if (key.startsWith(prefix)) {
            delete workflow[key];
          }
        });
      }
    },

    clearWorkflow(state, action: PayloadAction<{ workflowId: string }>) {
      delete state.workflows[action.payload.workflowId];
    },
  },
});

export default tabScrollSlice.reducer;
export const tabScrollActions = tabScrollSlice.actions;

export const selectTabScrollPosition =
  (workflowId: string, scrollKey: string) =>
  (state: RootState): number | null =>
    state.tabScrollSlice.workflows[workflowId]?.[scrollKey] ?? null;
